var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExtArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.74,
    height: 13.75,
    viewBox: "0 0 49.74 13.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,8.62H40.54s.04,4.52,.04,4.52c0,.2,.11,.5,.26,.58,.15,.08,.47,0,.63-.11,2.65-2.07,5.28-4.16,7.91-6.25,.5-.4,.48-.62-.04-1.04-1.09-.87-2.19-1.74-3.3-2.6-1.54-1.19-3.08-2.37-4.64-3.54-.16-.12-.47-.23-.61-.15-.17,.1-.28,.38-.31,.6-.05,.38-.02,.76-.02,1.14l.03,3.37H0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExtArrow);
export default __webpack_public_path__ + "static/media/icon_ExtArrow.5c78af8aef8c9b1f3b82d721fcdbe6e8.svg";
export { ForwardRef as ReactComponent };